import Vue from 'vue'
import App from '@/App'
import axios from 'axios'
import moment from 'moment-timezone'
// import moment from 'moment'
import swal from 'sweetalert'
import Notify from 'vue-notifyjs'
import router from './router'
// import 'es6-promise/auto'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
// import "font-awesome/css/font-awesome.min.css";
import { faKaaba, faMapMarkerAlt, faCog, faUserCog, faSignOutAlt, faUser, faMosque, faListUl, faPlaneDeparture, faPlane, faHotel, faClock, faChevronLeft, faChevronRight, faChevronDown, faChevronUp, faUserAlt, faCalendarAlt, faTag, faUserCircle, faPencilAlt, faExchangeAlt, faIdCard, faSpinner, faPlus, faTimes, faExclamation, faHome, faCoins, faTags, faCalendarDay, faInfoCircle, faStar, faCheck, faEdit, faList, faMoneyBillAlt, faEyeDropper, faTrash, faQuestionCircle, faCheckCircle, faBan, faReceipt, faCalendar, faCreditCard, faSave, faCodeBranch, faInfo, faSearch, faTimesCircle, faScroll, faChevronCircleLeft, faClipboardList, faCommentsDollar, faFileSignature, faBars, faCar, faShippingFast, faGasPump, faFileInvoiceDollar, faBell, faFileInvoice, faFileAudio, faCalendarWeek, faImages, faUserTag, faHandHoldingUsd, faDollarSign, faDownload, faDonate, faBuilding, faUsers, faLightbulb, faToggleOn, faAddressBook, faPhoneVolume, faGraduationCap, faUserTie, faFolderOpen, faFilePdf, faQrcode, faPrint, faChartLine, faUnlock, faKey, faSearchDollar } from '@fortawesome/free-solid-svg-icons'
import { faInstagram as fabInstagram, faFacebook as fabFacebook, faTwitter as fabTwitter, faYoutube as fabYoutube, faGoogle as fabGoogle } from '@fortawesome/free-brands-svg-icons'
import { faStar as farStar} from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VeeValidate, { Validator } from 'vee-validate'
import id from '../node_modules/vee-validate/dist/locale/id.js'
import vSelect from 'vue-select'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

try {
  // import uploader from 'vue-simple-uploader'
  require('./functions')

  require('./config/' + process.env.NODE_ENV)
  //console.log(process.env.NODE_ENV)
  //console.log(window.AppConfig)

  if (store.getters['account/isLoggedIn']) {
    store.dispatch('account/saveTokens', {tokens: store.getters['account/tokens'], accountData: null, isLocalLogin: true}).catch(error => {
      if (error === 'I\'m so sorry, You don\'t have permission to access on this website.') {
        store.dispatch('notification/error', error)
        router.push('logout')
      }
    })
  }

  library.add(faKaaba, faMapMarkerAlt, faCog, faUserCog, faUser, faMosque, faListUl, faPlaneDeparture, faMapMarkerAlt, faPlane, faHotel, faPlaneDeparture, faClock, faChevronLeft, faChevronRight, faChevronDown, faChevronUp, faSignOutAlt, faUserAlt, faCalendarAlt, faTag, faUserCircle, faPencilAlt, faExchangeAlt, faIdCard, faSpinner, faPlus, faTimes, faExclamation, faHome, faCoins, faTags, faCalendarDay, faInfoCircle, faStar, faPlaneDeparture, faCheck, faEdit, fabInstagram, fabFacebook, fabTwitter, faKaaba, faList, faIdCard, faMoneyBillAlt, faEyeDropper, faTrash, faQuestionCircle, farStar, fabYoutube, faCheckCircle, faBan, fabGoogle, faReceipt, faCalendar, faCreditCard, faSave, faCodeBranch, faInfo, faSearch, faTimesCircle, faList, faScroll, faChevronCircleLeft, faUserCog, faClipboardList, faCommentsDollar, faFileSignature, faBars, faCar, faShippingFast, faGasPump, faFileInvoiceDollar, faBell, faFileInvoice, faFileAudio, faCalendarWeek, faImages, faUserTag, faHandHoldingUsd, faDollarSign, faDownload, faCommentsDollar, faDonate, faBuilding, faUsers, faLightbulb, faToggleOn, faAddressBook, faPhoneVolume, faGraduationCap, faUserTie, faFolderOpen, faFilePdf, faQrcode, faPrint, faChartLine, faUnlock, faKey, faSearchDollar)
  Vue.use(VueGoogleMaps, {
    load: {
      key: window.AppConfig.googleApiKey,
      libraries: 'places',
      installComponents: true,
    }
  })
  Vue.config.productionTip = false
  Vue.use(BootstrapVue)
  Vue.use(VueSidebarMenu)
  Vue.use(IconsPlugin)
  Vue.use(Notify)

  moment.tz.setDefault('Asia/Kuala_Lumpur')
  // Vue.use(uploader)
  Vue.component('v-select', vSelect)
  Vue.use(VeeValidate, { fieldsBagName: 'veeFields' })
  Validator.localize('id', id)
  // import { ToggleButton } from 'vue-js-toggle-button'
  Vue.component('font-awesome-icon', FontAwesomeIcon)
  // Vue.component('ToggleButton', ToggleButton)

  // moment.tz.setDefault('Asia/Jakarta')
  // moment.locale('id-ID')
  Vue.prototype.$moment = moment
  Vue.prototype.$http = axios
  Vue.prototype.$swal = swal

  Vue.prototype.$formatCurrency = function (number, localeCode = 'id-ID') {
    return new Intl.NumberFormat(localeCode.replace('_', '-'), {minimumFractionDigits: 0}).format(number)
  }

  Vue.prototype.$openLink = function (targetLink) {
    window.open(targetLink, '_blank')
  }

  new Vue({
    render: h => h(App),
    router,
    store
  }).$mount('#app')

} catch (ex) {
  alert('Cannot find config file!')
  // console.log(ex)
}
